module.exports = __webpack_public_path__ + "static/media/icon-dropdown-arrow-filled.7d45d77a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-dropdown-arrow-filled.svg
// module id = 691
// module chunks = 0